export const BackgroundFixedClasses = {
  BACKGROUND_FIXED: ['wf-bg-fixed'],
  BACKGROUND_SCROLL: ['wf-bg-scroll'],
}

export const BackgroundPositionClasses = {
  BACKGROUND_LEFT: ['wf-bg-left'],
  BACKGROUND_LEFT_BOTTOM: ['wf-bg-left-bottom'],
  BACKGROUND_LEFT_TOP: ['wf-bg-left-top'],
  BACKGROUND_RIGHT: ['wf-bg-right'],
  BACKGROUND_RIGHT_BOTTOM: ['wf-bg-right-bottom'],
  BACKGROUND_RIGHT_TOP: ['wf-bg-right-top'],
  BACKGROUND_TOP: ['wf-bg-top'],
  BACKGROUND_BOTTOM: ['wf-bg-bottom'],
  BACKGROUND_CENTER: ['wf-bg-center'],
}

export const BackgroundRepeatClasses = {
  BACKGROUND_REPEAT: ['wf-bg-repeat'],
  BACKGROUND_NO_REPEAT: ['wf-bg-no-repeat'],
  BACKGROUND_REPEAT_X: ['wf-bg-repeat-x'],
  BACKGROUND_REPEAT_Y: ['wf-bg-repeat-y'],
  BACKGROUND_REPEAT_ROUND: ['wf-bg-repeat-round'],
  BACKGROUND_REPEAT_SPACE: ['wf-bg-repeat-space'],
}

export const BackgroundSizeClasses = {
  BACKGROUND_COVER: ['wf-bg-cover'],
  BACKGROUND_CONTAIN: ['wf-bg-contain'],
  BACKGROUND_AUTO: ['wf-bg-auto']
}